module.exports = __webpack_public_path__ + "static/fleetAll-a2860d4be261d7507a703366ca81d259.png";